import React from "react";
import ReactDom from "react-dom";
import Calculator from "./Calculator.jsx";
import { 
  mortgageCalculatorConfig, 
  calculateMortgage,
  amortizationConfig,
  calculateAmortization,
  printSchedule,
  deedDocumentaryStampsConfig,
  calculateDeedDocumentaryStamps,
  titleInsuranceConfig,
  calculateTitleInsurance
} from "./calculators";

// Map of calculator types to their configs and calculation functions
const calculatorMap = {
  mortgage: {
    config: mortgageCalculatorConfig,
    calculateFunction: calculateMortgage
  },
  amortization: {
    config: amortizationConfig,
    calculateFunction: calculateAmortization,
    printScheduleFunction: printSchedule
  },
  deedDocumentaryStamps: {
    config: deedDocumentaryStampsConfig,
    calculateFunction: calculateDeedDocumentaryStamps
  },
  titleInsurance: {
    config: titleInsuranceConfig,
    calculateFunction: calculateTitleInsurance
  }
};

export function renderCalculators() {
  document.querySelectorAll(".js-calculator").forEach((mount, i) => {
    const calculatorType = mount.dataset.type;
    const calculator = calculatorMap[calculatorType];
    
    if (!calculator) {
      console.warn(`Unknown calculator type: ${calculatorType}`);
      return;
    }

    ReactDom.render(
      <Calculator
        title={calculator.config.title}
        inputs={calculator.config.inputs}
        outputs={calculator.config.outputs}
        calculateFunction={calculator.calculateFunction}
        id={`calculator-${calculatorType}-${i}`}
        printScheduleFunction={calculator.printScheduleFunction}
      />,
      mount
    );
  });
}
